module.exports = __webpack_public_path__ + "static/img/uu60.16c11a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uu60.png
// module id = 298
// module chunks = 1